module.exports = __webpack_public_path__ + "static/img/Cladding_Composite.bf36d76.jpg";